// extracted by mini-css-extract-plugin
export default {"radio":"radio_radio__CI4Mh","small":"radio_small__uDUed","medium":"radio_medium__yP7uQ","large":"radio_large__dYC49"};